// Simple notification system - can be integrated with your UI library
export const showNotification = (type: 'success' | 'error' | 'info' | 'warning', message: string) => {
  console.log(`[${type.toUpperCase()}] ${message}`);
  // Integrate with your UI notification system here
  // e.g., toast.success(message), alert(message), etc.
};